import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Tooltip } from '@mui/material';
import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';
import { Badge } from 'reactstrap';
import { Practice } from '../../model/types';

interface PracticeColumnsProps {
  data: Practice[];
  onEdit: (practice: Practice) => void;
  onDelete: (practice: Practice) => void;
  onDetail: (practice: Practice) => void;
  t: (key: string) => string;
}

const PracticeColumns = ({ data, onEdit, onDelete, onDetail, t }: PracticeColumnsProps) => {
  const columns = [
    {
      name: t('practice.name'),
      selector: (row: Practice) => row.name,
      sortable: true,
    },
    {
      name: t('practice.description'),
      selector: (row: Practice) => row.description ?? '—',
      sortable: false,
    },
    {
      name: t('practice.status'),
      cell: (row: Practice) =>
        row.active ? (
          <Badge color="success">{t('practice.active')}</Badge>
        ) : (
          <Badge color="danger">{t('practice.inactive')}</Badge>
        ),
      sortable: false,
    },
    {
      name: t('actions'),
      cell: (row: Practice) => (
        <div>
          <Tooltip title={t('more_details')} onClick={() => onDetail(row)}>
            <IconButton>
              <InfoOutlinedIcon style={{ fill: '#3b82f6', fontSize: '22px' }} />
            </IconButton>
          </Tooltip>
          <Tooltip title={t('edit')} onClick={() => onEdit(row)}>
            <IconButton>
              <EditOutlinedIcon style={{ fill: '#f59e0b', fontSize: '22px' }} />
            </IconButton>
          </Tooltip>
          <Tooltip title={t('delete_practice')} onClick={() => onDelete(row)}>
            <IconButton>
              <DeleteOutlineRoundedIcon style={{ fill: '#ef4444', fontSize: '22px' }} />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      pagination={false}
      highlightOnHover
      responsive
      noDataComponent={t('practice.no_practice')}
    />
  );
};

export default translate(PracticeColumns);
